import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CookieBannerComponent } from '../gdpr/cookies/cookie-banner/cookie-banner.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, CookieBannerComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}